var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"float-right m-1",attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":_vm.agir}},[_c('font-awesome-icon',{staticClass:"mx-1 mx-sm-0 mr-sm-2",attrs:{"icon":"chevron-left"}}),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Voltar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }